import { render, staticRenderFns } from "./PriceLegend.vue?vue&type=template&id=0ada7612&scoped=true"
import script from "./PriceLegend.vue?vue&type=script&lang=js"
export * from "./PriceLegend.vue?vue&type=script&lang=js"
import style0 from "./PriceLegend.vue?vue&type=style&index=0&id=0ada7612&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ada7612",
  null
  
)

export default component.exports